import type {i18n as I18nInstance} from "i18next";
import type {Lang} from "../language";

export type FlatTranslations = Record<string, string>;

export function loadProjectBundle(i18n: I18nInstance, lang: Lang, data: FlatTranslations) {
    i18n.addResourceBundle(lang, "project", data, true, true);
}

export function clearProjectBundle(i18n: I18nInstance, langs: Lang[]) {
    for (const lang of langs) {
        try {
            if (i18n.hasResourceBundle(lang, "project")) {
                i18n.removeResourceBundle(lang, "project");
            }
        } catch {

        }
    }
}
